<template>
    <section ref="accordionRef" class="js-accordion">
        <slot />
    </section>
</template>

<script setup lang="ts">
const props = defineProps<{
    oneAccordionOpen?: boolean
}>()
const accordionRef = ref(null)

onMounted(() => {
    if (accordionRef.value) {
        accordionRef.value.querySelectorAll(".js-accordion-trigger").forEach(accordionTrigger => {
            accordionTrigger.addEventListener("click", handleAccordionTriggerClick)
        })
    }
})

function handleAccordionTriggerClick() {
    const currentClickedSection = this.parentNode
    const currentActiveSection = this.closest(".js-accordion").querySelector(".is-open")

    if(props.oneAccordionOpen) {
        if (currentActiveSection && currentActiveSection !== currentClickedSection) {
            currentActiveSection.classList.remove("is-open")
        }
    }

    currentClickedSection.classList.toggle("is-open")
}
</script>

<style scoped></style>
